import { render, staticRenderFns } from "./ArrowsAltVIcon.vue?vue&type=template&id=058b6139&"
import script from "./ArrowsAltVIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowsAltVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports